import React from 'react';
import styled from 'styled-components';
import {VideoInfo} from 'shared/components/VideoPlayer/entity/VideoInfo';
import {Thumbnail} from 'shared/components/VideoPlayer/Thumbnail';

interface VideoProp {
    videoInfo: VideoInfo;
    index: number;
    onClick: () => void;
    watched?: boolean;
}

export const Video = ({
    videoInfo,
    index,
    onClick,
    watched = false,
}: VideoProp) => (
    <Card
        type="button"
        onClick={onClick}
        aria-label={`Play ${videoInfo.title}, ${videoInfo.duration}${
            watched ? ', watched' : ''
        }`}>
        <Thumbnail videoInfo={videoInfo} watched={watched} />
        <Details>
            <Title>
                {index + 1}. {videoInfo.title}
            </Title>
            <Description>{videoInfo.shortDescription}</Description>
        </Details>
    </Card>
);

const Card = styled.button`
    display: flex;
    flex-direction: column;
    padding: 0;
    text-align: left;
    background: #fff;
    border: 1px solid #dce6ed;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition:
        box-shadow 0.15s,
        border-color 0.15s;

    &:hover,
    &:focus-visible {
        border-color: ${({theme}) => theme.colors.secondary.main};
        box-shadow: 0 4px 14px rgba(32, 67, 128, 0.12);
    }
`;

const Details = styled.div`
    padding: 10px 12px 12px;
`;

const Title = styled.div`
    font-weight: 600;
    font-size: 0.95em;
    line-height: 1.3;
    color: ${({theme}) => theme.colors.primary.main};
`;

const Description = styled.div`
    margin-top: 4px;
    font-size: 0.8em;
    color: #60788e;
`;
